export default __webpack_public_path__ + "static/media/country.3d111f98.jpg";